module.exports = __webpack_public_path__ + "static/media/img1-3.691fd675.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/nutricheck_foliar/N/img1-3.png
// module id = 2056
// module chunks = 3